import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Spinner from '../spinner';

import './progress-image.css';

export default class ProgressImage extends Component {
  constructor(props) {
    super(props);
    const state = {
      error: false,
      isLoaded: false,
    };

    const { image, hover, size } = props;

    if (!image) {
      state.error = 'No image specified';
    } else {
      const mainImage = image.sizes[size];
      if (!mainImage) {
        state.error = 'Image Not Found';
      } else {
        state.mainImage = mainImage;

        const hoverImage = hover ? hover.sizes[size] : null;
        state.hoverImage = hoverImage;

        if (typeof Image !== 'undefined') {
          if (mainImage) {
            const mainImagePreloader = new Image();
            mainImagePreloader.onload = () => {
              if (!this.unmounted) this.setState({ isLoaded: true });
            };
            mainImagePreloader.src = mainImage.src;
          }

          if (Image && hoverImage) {
            const hoverImagePreloader = new Image();
            hoverImagePreloader.src = hoverImage.src;
          }
        }
      }
    }

    this.unmounted = false;
    this.state = state;
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    const {
      image, style, width, height, aspectRatio,
    } = this.props;
    if (!image) return null;

    const {
      mainImage, hoverImage, isLoaded, error,
    } = this.state;

    const outerstyle = style ? Object.assign({}, style) : {};
    if (width) outerstyle.width = width;
    if (height) outerstyle.height = height;

    if (width && !height) {
      const ratio = aspectRatio || image.sizes.full.height / image.sizes.full.width;
      outerstyle.height = 0;
      outerstyle.paddingTop = `${ratio * 100}%`;
    } else if (height && !width) {
      const ratio = aspectRatio || image.sizes.full.width / image.sizes.full.height;
      outerstyle.width = 0;
      outerstyle.paddingLeft = `${ratio * 100}%`;
    }

    let classNames = 'progress-image';
    if (isLoaded) classNames += ' pi-loaded';

    return (
      <div className={classNames} style={outerstyle}>
        <div className="pi-thumb" style={{ backgroundImage: `url(${image.thumb})` }} />
        {mainImage ? <div className="pi-image" style={{ backgroundImage: `url(${mainImage.src})` }} /> : null}
        {hoverImage ? <div className="pi-hover" style={{ backgroundImage: `url(${hoverImage.src})` }} /> : null}
        {error ? <div className="pi-error">{error}</div> : null}
        {!isLoaded ? <div className="pi-loading"><Spinner scale={0.5} /></div> : null}
      </div>
    );
  }
}

ProgressImage.propTypes = {
  image: PropTypes.object.isRequired,
  size: PropTypes.string,
  hover: PropTypes.object,
  style: PropTypes.object,
  width: PropTypes.any,
  height: PropTypes.any,
  aspectRatio: PropTypes.number,
};

ProgressImage.defaultProps = {
  size: 'full',
  hover: null,
  style: {},
  width: null,
  height: null,
  aspectRatio: null,
};



// WEBPACK FOOTER //
// ./src/components/progress-image/index.jsx